import { writable } from 'svelte/store';

export type WishFeature = {
	feature: string;
	vote: true | false | null;
};

export type FeatureClicked = {
	feature: string;
	clicks: number;
};

export let wishListFeatureStore = writable<WishFeature[]>([]);

export let featuresClicked = writable<FeatureClicked[]>([]);

export function loadFeaturesVotesFromData(data: WishFeature[]) {
	wishListFeatureStore.set(data);
}

export function loadFeaturesClickedFromData(data: FeatureClicked[]) {
	featuresClicked.set(data);
}
